import React from 'react';
import { Gift, Minus, Plus } from 'lucide-react';

export default function OfferingItem({ item, price = item.price, quantity, onQuantityChange }) {
  return (
    <div data-testid={`offering-${item.id}`}
      className={`p-3 rounded-2xl border flex items-center justify-between gap-3 transition-colors ${
        quantity > 0 ? 'bg-orange-50/50 border-[#D9711F]' : 'bg-white border-gray-200'
      }`}>
      <div className="flex min-w-0 items-center gap-3">
        {item.image_url ? (
          <img src={item.image_url} alt={item.name} className="w-12 h-12 rounded-xl object-cover border border-gray-200 shrink-0" />
        ) : (
          <div className="w-12 h-12 rounded-xl bg-[#FBF4E7] flex items-center justify-center shrink-0">
            <Gift className="w-5 h-5 text-[#D9711F]" />
          </div>
        )}
        <div className="min-w-0">
          <h5 className="font-bold text-xs text-[#2A1F16] break-words">{item.name}</h5>
          <p className="text-[11px] text-gray-500 line-clamp-1">{(item.description || '').replace(/<[^>]*>/g, '')}</p>
          <span className="font-price font-bold text-xs text-[#6E1B34]">₹{price}</span>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {quantity > 0 && (
          <button type="button" aria-label={`Remove ${item.name}`} onClick={() => onQuantityChange(Math.max(0, quantity - 1))}
            className="w-7 h-7 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center">
            <Minus className="w-3.5 h-3.5" />
          </button>
        )}
        <span aria-label={`${item.name} quantity`} className={`text-xs font-bold w-4 text-center ${quantity > 0 ? 'text-[#6E1B34]' : 'text-gray-400'}`}>{quantity}</span>
        <button type="button" aria-label={`Add ${item.name}`} onClick={() => onQuantityChange(quantity + 1)}
          className="w-7 h-7 rounded-lg bg-[#6E1B34] hover:bg-[#4E1225] text-white flex items-center justify-center">
          <Plus className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
